import { ProBadge } from "@/components/ProBadge";
import { ForkKnife } from "@phosphor-icons/react";

const CDN = "https://static.prod-images.emergentagent.com/jobs/1c99ae62-8685-472e-a2e2-81195b861c24/images";
const FOOD_IMG = {
  yogurt: `${CDN}/f6215c7f699336ab41bef1d1df8a87f11ee9d74ff3bb87fdfdb427749086b5a4.jpeg`,
  eggs: `${CDN}/3fec09802bef0c7d3c6180f0a5abb42c200aee9296328ecb800fa63383250365.jpeg`,
  oats: `${CDN}/8ec9f4d2620d25c6c1411e601e2c691da855ca7cc33fdb7921e22be35844b718.jpeg`,
  smoothie: `${CDN}/3a603614070c5227337ff1fe02db7ea304c044020c462cbb7dbba0a2bcf52cd0.jpeg`,
  salmon: `${CDN}/634b9f327674e216c6d5b7c291ba9ac04229770cca2a2e3e950990005b5bc95d.jpeg`,
  chicken: `${CDN}/7bd8caaecde2b18c74424cf4a67d3ab9ef1250e91f8b41036318d83d811838ab.jpeg`,
  salad: `${CDN}/ed800120785735ed32c71bfc704c77c55d5c7f05e875b183eedd9c760045ec7f.jpeg`,
  bowl: `${CDN}/8d25e610007a65c9b6292a340834a0d496514f234af64818a37101abf07b4c5b.jpeg`,
  soup: `${CDN}/39cfce425cf6fbe09e7584c266a495ac267fbfe4ffd49bb840fbbb66c71b6db2.jpeg`,
  fruit: `${CDN}/7c19455a4772fbcc0f3639276d6a2df0e2f0e6b5e31c04f7319cedcbcbb28526.jpeg`,
};

const guessKey = (title = "") => {
  const t = title.toLowerCase();
  const pairs = [["yogurt", "yogurt"], ["egg", "eggs"], ["oat", "oats"], ["porridge", "oats"], ["smoothie", "smoothie"],
    ["salmon", "salmon"], ["fish", "salmon"], ["chicken", "chicken"], ["turkey", "chicken"], ["salad", "salad"],
    ["soup", "soup"], ["fruit", "fruit"], ["nut", "fruit"], ["berr", "fruit"]];
  for (const [k, v] of pairs) if (t.includes(k)) return v;
  return "bowl";
};

export default function NutritionCard({ nutrition }) {
  if (!nutrition) return null;
  const goal = nutrition.goal || nutrition.headline;
  return (
    <div className="clay p-6" data-testid="nutrition-card">
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-xl bg-stress/15 flex items-center justify-center">
          <ForkKnife size={18} weight="fill" color="#E8A54B" />
        </div>
        <span className="label-eyebrow flex items-center gap-2">Adaptive nutrition <ProBadge testId="pro-badge-nutrition" /></span>
      </div>
      {goal && <p className="text-[15px] mt-4 leading-snug font-medium" data-testid="nutrition-goal">{goal}</p>}
      <div className="mt-4 grid grid-cols-2 gap-2.5">
        {(nutrition.meals || []).map((m, i) => {
          const img = FOOD_IMG[m.food_key] || FOOD_IMG[guessKey(m.title)];
          return (
            <div key={i} className="rounded-2xl overflow-hidden bg-secondary/60" data-testid={`meal-${(m.slot || "").toLowerCase()}`}>
              <div className="relative h-20">
                <img src={img} alt={m.title} loading="lazy" className="w-full h-full object-cover" />
                <span className="absolute top-1.5 left-1.5 text-[10px] font-bold uppercase tracking-wider text-white rounded-full px-2 py-0.5"
                  style={{ backgroundColor: "rgba(10,15,30,0.66)", backdropFilter: "blur(4px)" }}>
                  {m.slot}
                </span>
              </div>
              <div className="px-2.5 py-2">
                <div className="text-[13px] font-medium leading-tight">{m.title}</div>
                {m.why && <div className="text-[11px] text-muted2 mt-0.5">{m.why}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
